import { Network } from 'ui-utilities';
import { store } from '../store';
import { APP } from '../constants/SiteVariables';
import * as entitiesActions from '../actions/entities';

export const Base = Base => class extends Base {
  constructor(props) {
    super(props);

    if (store) {
      this._api = Network(store, APP);
      this._store = store;
      this._dispatch = store.dispatch;
      this._state = store.getState;
    }
  }

  set api(val) {
    this._api = val
  }

  set actions(val) {
    this._actions = val;
  }

  set store(val) {
    this._store = val;
    this._dispatch = val.dispatch;
    this._state = val.getState;
  }

  get api() {
    if (!this._api) this.api = Network(store);
    return this._api;
  }

  get dispatch() {
    if (!this._store) this.store = store;
    return this._dispatch;
  }

  get actions() {
    if (!this._actions) this.actions = entitiesActions;
    return this._actions;
  }

  get state() {
    if (!this._store) this.store = store;
    return this._state();
  }

  $proxy(record, id, resource, showAll) {
    if (!record) return Promise.reject('No record specified');

    return record.$get(id, resource, showAll);
  }
}



// WEBPACK FOOTER //
// ./src/records/base.js